import { Component, OnInit } from '@angular/core';

@Component({ selector: 'sd-courses', templateUrl: './courses.component.html' })
export class CoursesComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
